module.exports = __webpack_public_path__ + "img/葛根.2e1feb06.jpg";